import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { formatBusinessDate, formatDateOnly } from "@helpers/date";
import { MatchableItem } from "../types";

export const DateCell = memo(
    ({ row }: CellContext<ViewTableFeatures, MatchableItem, unknown>) => {
        if (row.depth > 0) {
            return <ViewTableCell />;
        }

        return (
            <ViewTableCell>
                {row.original.dateOnly
                    ? formatDateOnly(row.original.dateOnly)
                    : formatBusinessDate(row.original.date)}
            </ViewTableCell>
        );
    },
);
DateCell.displayName = "DateCell";
